import(/* webpackMode: "eager" */ "/var/www/restroagent/src/app/(landing)/about/page.tsx");
